// Super Admin nav icons and page frame. The shared cards, fields and buttons
// live in components/isd.jsx and are re-exported here.

import {
  Activity,
  Bell,
  Building2,
  Car,
  IndianRupee,
  Layers,
  Map,
  MessageSquareText,
  Route,
  ShieldCheck,
  SlidersHorizontal,
  Store,
  Users,
} from "lucide-react";

// One icon set (lucide, the same family the dashboard nav uses) at one stroke.
const icon = (Icon) => <Icon width="17" height="17" strokeWidth={1.9} />;

export const ICONS = {
  route: icon(Route),
  bell: icon(Bell),
  map: icon(Map),
  store: icon(Store),
  car: icon(Car),
  users: icon(Users),
  shield: icon(ShieldCheck),
  sliders: icon(SlidersHorizontal),
  building: icon(Building2),
  layers: icon(Layers),
  pulse: icon(Activity),
  message: icon(MessageSquareText),
  rupee: icon(IndianRupee),
};

export * from "../../components/isd";

// Page title.
export function PageHeader({ title }) {
  return (
    <div className="pt-2">
      <h1 className="text-[26px] font-semibold leading-[34px] tracking-[-0.02em] text-[#101828]">{title}</h1>
    </div>
  );
}

export function Page({ children, maxWidth = 1240 }) {
  return (
    <div className="px-8 pb-16 pt-4" style={{ maxWidth }}>
      {children}
    </div>
  );
}

export function initials(name) {
  return (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}
